import { postRoute } from "../client"
export const saveProfileRoute = postRoute<{ success: boolean; error?: string }>("/api/profile")
